import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppointmentInfoReponseModel } from 'src/app/shared/models/response/appointment/appointment-info-reponse-model';
import { AppointmentSummaryResponseModel } from 'src/app/shared/models/response/appointment/appointment-summary-response-model';
import { AppointmentUpdateStatusRequestModel } from 'src/app/shared/models/response/appointment/appointment-updatestatus-request-model';
import { TherapistAvailability } from 'src/app/shared/models/response/appointment/available-slots';
import { WIPStatesResponseModel } from 'src/app/shared/models/response/appointment/wip-states-response-model';
import { FacilityInfoResponseModel } from 'src/app/shared/models/response/facility/facilityinfo-response-model';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { BaseService } from 'src/app/shared/services/base.service';
import {
  SchedulerResponseModelForExport,
  SchedulerResponseModel,
  SchedulerTherapistResponseModel,
  SchedulerResponseModelForExportFinal
} from 'src/app/shared/models/response/therapist/therapist-appointments-response-model';
import { WebStorageService } from '../../shared/services/web-storage.service';
import {
  TherapistAppointmentsByAppointmenType,
  TherapistBlockAvailabilityData
} from 'src/app/shared/models/response/appointment/therapist-appointment-by-appointment_type';
import { RoadHomeVisitHistoryResponseModel } from 'src/app/shared/models/request/roadHomeVisitHistory-request';
import { AppointmentTypeResponseModel } from 'src/app/shared/models/response/appointment-type-response-model';
import { TherapistAppointmentSearchRequestModel } from 'src/app/shared/models/request/therapist/therapist-appointment-request-model';

@Injectable({
  providedIn: 'root'
})
export class TheraistAppointmentService extends BaseService {
  constructor(httpClinet: HttpClient, webStorageService: WebStorageService) {
    super(httpClinet, webStorageService);
  }

  GetAllWIPStatesBySalesOrderType(salesOrderType: string) {
    return this.get<ResultOfT<WIPStatesResponseModel[]>>('Appointment/GetAllWIPStatesBySalesOrderType?salesOrderType=' + salesOrderType);
  }

  GetAllAppointmentsByTherapist(therapistId: string, appointmentDate: string) {
    return this.get<ResultOfT<AppointmentSummaryResponseModel[]>>('Appointment/GetAppointmentsTherapistWise?therapistId=' + therapistId + '&date=' + appointmentDate);
  }

  GetTherapistAppointment(therapistId: number, appointmentDate: string) {
    return this.get<ResultOfT<AppointmentInfoReponseModel[]>>('Therapist/GetTherapistAppointment?therapistId=' + therapistId + '&appointmentDate=' + appointmentDate);
  }

  UpdateAppointmentStatus(salesorders: AppointmentUpdateStatusRequestModel[]) {
    return this.post<ResultOfT<boolean>>('Appointment/UpdateAppointmentStatus', salesorders);
  }

  CheckAppointmentUpdatedStatus(salesorders: AppointmentUpdateStatusRequestModel[]) {
    return this.post<ResultOfT<boolean>>('Appointment/CheckAppointmentUpdatedStatus', salesorders);
  }
  GetAppointmentById(AppointmentId: number) {
    return this.get<ResultOfT<AppointmentInfoReponseModel>>('Appointment/GetAppointmentById/' + AppointmentId);
  }

  GetTherapistAvailability(therapistId: number, dtDate: string) {
    return this.get<ResultOfT<TherapistAvailability[]>>('Appointment/GetTherapistAvailability/' + therapistId + '/' + dtDate);
  }

  GetTherapistAppointments(therapistId: number, appointmentDate: string, isRefresh: boolean) {
    if (isRefresh)
      return this.get<ResultOfT<SchedulerResponseModelForExportFinal>>(
        'Therapist/GetTherapistAppointmentForExport?therapistId=' + therapistId + '&appointmentDate=' + appointmentDate + '&rnd=' + Math.random().toString()
      );
    else
      return this.get<ResultOfT<SchedulerResponseModelForExportFinal>>(
        'Therapist/GetTherapistAppointmentForExport?therapistId=' + therapistId + '&appointmentDate=' + appointmentDate
      );
  }

  DownloadTherapistAppointmentsCSV(therapistId: number, appointmentDate: string) {
    return this.downloadCsvFile('Therapist/GetTherapistAppointmentExportCSV/' + therapistId + '/' + appointmentDate);
  }

  UpdateAppointmentDetailComment(appointment: AppointmentUpdateStatusRequestModel) {
    return this.post<ResultOfT<boolean>>('Appointment/UpdateAppointmentDetailComment', appointment);
  }

  GetWeekWiseAppointmentsOfTherapists(therapistId: number, weekcurrentDate: string) {
    var url = 'Therapist/GetTherapistAppointmentByWeek?therapistId=' + therapistId;
    url = url + '&weekcurrentDate=' + weekcurrentDate;
    return this.get<ResultOfT<SchedulerResponseModel[]>>(url);
  }

  getRoadHomeHistory(therapistId: number, appoinemtnDate: string) {
    return this.get<ResultOfT<RoadHomeVisitHistoryResponseModel[]>>(
      'RoadShowGoogleMap/GetRoadHomeVisitHistory?crmTherapistId=' + therapistId + '&appointmentStartDate=' + appoinemtnDate
    );
  }

  GetTherapistScheduledAppointment(therapistId: number, appointmentDate: string) {
    return this.get<ResultOfT<TherapistAppointmentsByAppointmenType>>(
      'Therapist/GetTherapistScheduledAppointment?therapistId=' + therapistId + '&appointmentDate=' + appointmentDate
    );
  }

  GetAllNotAvailableTherapistSlotByDate(therapistId: number, appointmentDate: string) {
    return this.get<ResultOfT<TherapistBlockAvailabilityData[]>>(
      'Therapist/GetAllNotAvailableTherapistSlotByDate?therapistId=' + therapistId + '&appointmentDate=' + appointmentDate
    );
  }

  GetAllAppointmentType() {
    return this.get<ResultOfT<AppointmentTypeResponseModel[]>>('AppointmentType/GetAllAppointmentType');
  }

  GetTherapistAppointmentForMobileCalender(therapistId: number, weekcurrentDate: string, appointmentType: number) {
    return this.get<ResultOfT<SchedulerResponseModel[]>>(
      'Therapist/GetTherapistAppointmentForMobileCalender?therapistId=' + therapistId + '&weekcurrentDate=' + weekcurrentDate + '&appointmentType=' + appointmentType
    );
  }

  GetTherapistAppointmentForExportWeekViewDME(therapistId: number, appointmentDate: string, isRefresh: boolean) {
    if (isRefresh)
      return this.get<ResultOfT<SchedulerResponseModelForExportFinal>>(
        'Therapist/GetTherapistAppointmentForExportWeekViewDME?therapistId=' + therapistId + '&appointmentDate=' + appointmentDate + '&rnd=' + Math.random().toString()
      );
    else
      return this.get<ResultOfT<SchedulerResponseModelForExportFinal>>(
        'Therapist/GetTherapistAppointmentForExportWeekViewDME?therapistId=' + therapistId + '&appointmentDate=' + appointmentDate
      );
  }

  GetTherapistAppointmentsExportCSVWeekViewDME(therapistId: number, appointmentDate: string) {
    return this.downloadCsvFile('Therapist/GetTherapistAppointmentsExportCSVWeekViewDME/' + therapistId + '/' + appointmentDate);
  }
}
